import React, { useState } from "react";
import { RCCButton, RCCGrid, RCCHookToast, RCCSelectOptionsCard, RCCTooltip } from "react-common-components";
import { useLocation } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import PageTitle from "src/components/PageTitle";
import { useAuth } from "src/context/Auth/context";
import { useTranslation } from "src/context/Translations/context";
import getUrlSearchParams from "src/utils/getUrlSearchParams";
import { getLocalStorage, setLocalStorage } from "src/utils/localStorage";
import DefaultKanban from "./kanbanModes/DefaultKanban";
import MultipleKanban from "./kanbanModes/MultipleKanbans";

const ActionsKanban: React.FC = () => {

	const query = useLocation();
	const objQueryParams = getUrlSearchParams(query.search);

	const { user } = useAuth();
	const { addToast } = RCCHookToast();

	const isDefaultView = () => {
		if(objQueryParams?.defaultKanban === "true")
			return true;
		if(objQueryParams?.id)
			return false;
		if(getLocalStorage(`KanbanModeShow-${user.efa005Id}`) !== "default")
			return false;

		return true;
	};

	const [isDefaultKanban, setIsDefaultKanban] = useState(isDefaultView());


	const { translate } = useTranslation();

	const setAsDefaultGrouper = () => {
		if(isDefaultKanban)
			setLocalStorage(`KanbanModeShow-${user.efa005Id}`, "default");
		else
			setLocalStorage(`KanbanModeShow-${user.efa005Id}`, "dynamic");

		addToast({
			color: "green",
			description: translate("Modo de visualização padrão atualizado com sucesso"),
			title: translate("Sucesso")
		});
	};

	return (
		<>
			<RCCGrid
				container
				item
				direction="column"
			>
				<PageTitle
					title="Kanban"
					icon={() => <AppIcons name="actions" />}
				>
					<RCCGrid
						container
						item
						xs={12}
						alignItems="center"
					>
						<RCCSelectOptionsCard
							defaultValue={isDefaultKanban ? "D": "M"}
							options={[{
								value: "D",
								label: translate("Kanban padrão")
							},{
								value: "M",
								label: translate("Kanbans dinâmicos")
							}]}
							onChange={(e) => {
								if(e === "D"){
									setIsDefaultKanban(true);
									return;
								}
								setIsDefaultKanban(false);
							}}
						/>
						<RCCTooltip
							color="grey"
							text={translate("Definir como modo de visualização padrão")}
							position="leftEnd"
						>
							<RCCButton 
								color="transparent"
								onClick={setAsDefaultGrouper}
								icon={{
									name: "checkBookmark",
									color: "var(--grey)"
								}}
							/>
						</RCCTooltip>
					</RCCGrid>

				</PageTitle>

				{isDefaultKanban ? (
					<DefaultKanban />
				) : (
					<MultipleKanban idKanban={objQueryParams?.id ? parseInt(objQueryParams?.id, 10) : undefined} />
				)}

			</RCCGrid>
		</>
	);
};

export default ActionsKanban;
